import { Link } from "@/components/link";

export function InfoRow({
  label,
  link,
  value,
}: {
  label: string;
  link?: string;
  value: null | number | string | undefined;
}) {
  return (
    <div className="flex justify-between items-start py-2">
      <span className="text-sm font-medium text-gray-500 min-w-0 flex-shrink-0 mr-4">
        {label}
      </span>
      {link ? (
        <Link
          className="text-text-brand-primary font-medium"
          href={link}
          target="_blank"
        >
          {value}
        </Link>
      ) : (
        <span className="text-sm text-text-primary text-right min-w-0 flex-1 font-medium">
          {value ?? "--"}
        </span>
      )}
    </div>
  );
}
